<div class="side-panel-container">

    <div [hidden]="page == sidePanelPages.HOMEPAGE">
        <app-side-panel-title></app-side-panel-title>
    </div>    
    
    <app-side-panel-products></app-side-panel-products>
    @switch (page) {

        <!-- @case(sidePanelPages.HOMEPAGE) {
            <div class="home-desc-txt">
                <p>Ti aiutiamo a scegliere quella giusta per te.</p>
            </div>
        } -->

        @case (sidePanelPages.SURVEY) {
            <div class="side-panel-tags-component-container">
                <app-side-panel-tags></app-side-panel-tags>
            </div>
        }

        @case (sidePanelPages.DIRECTSEARCH) {
            <app-side-panel-direct-search></app-side-panel-direct-search>
        }

    }

</div>